<script lang='ts'>
  import { getContext } from 'svelte'

  import { DIALOG_KEY, type DialogContext } from './dialog-context.js'

  import { cn } from '$lib/utils.js'

  const api = getContext<DialogContext>(DIALOG_KEY)

  export let to: string | HTMLElement | undefined = undefined

  let className = ''
  export { className as class }

  $: target = to ?? $api.portal

  function portal (node: HTMLElement) {
    const el = typeof target === 'string' ? document.querySelector(target) : target
    const mount = el ?? document.body

    mount.appendChild(node)

    return {
      destroy () {
        if (node.parentNode) node.remove()
      }
    }
  }
</script>

{#if $api.open}
  <div use:portal class={cn('fixed inset-0 z-50', className)} role='dialog'>
    <slot />
  </div>
{/if}
